<template></template>

<script>
export default {}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
